// This is to DRY the use of padding in the header of the theme. Its not a great solution.
// Frankly not sure padding should be part of the theme. But this was the least impactful way to
// fix this. This wasn't being used consistently in the code - so at least this will make it consistent.
const getHeaderPadding = (isMobile, hasLogoUrl, theme) =>
  isMobile
    ? hasLogoUrl && theme.header.hasLogo
      ? theme.header.paddingWithLogoMobile
      : theme.header.paddingMobile
    : hasLogoUrl && theme.header.hasLogo
      ? theme.header.paddingWithLogo
      : theme.header.padding

export { getHeaderPadding }
